import type { LeaseRepresentation } from '@/common/types/interaction';
import { InteractionType } from '@/common/types/interaction';
import {
  buildDualCoverSheetConfig,
  buildLandlordCoverSheetConfig,
  buildTenantCoverSheetConfig,
} from './lease';
import { buildListingCoverSheetConfig } from './listing/buildListingCoverSheetConfig';
import { buildOfferCoverSheetConfig } from './offer/buildOfferCoverSheetConfig';
import type { CoverSheetConfig } from './types';

/**
 * Gets the appropriate coversheet configuration based on interaction type and state
 */
export function getLocalCoverSheetConfig(
  state: string,
  interactionType: InteractionType,
  representationType?: LeaseRepresentation | null,
): CoverSheetConfig {
  if (interactionType === InteractionType.listing) {
    return buildListingCoverSheetConfig(state);
  }

  if (interactionType === InteractionType.offer) {
    return buildOfferCoverSheetConfig(state);
  }

  if (interactionType === InteractionType.lease) {
    if (representationType === 'landlord') {
      return buildLandlordCoverSheetConfig(state);
    }
    if (representationType === 'tenant') {
      return buildTenantCoverSheetConfig(state);
    }
    return buildDualCoverSheetConfig(state);
  }

  throw new Error(`Unsupported interaction type: ${interactionType}`);
}
